import React, { useEffect } from 'react';
import { X } from 'lucide-react';

// Dark-mode-aware modal shell, kept separate from components/ui/Modal.js so flows depending on that
// shared component aren't affected.
export default function InterviewModal({ isOpen, onClose, title, children, footer, isDarkMode }) {
  useEffect(() => {
    if (isOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'unset';
    return () => { document.body.style.overflow = 'unset'; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4 sm:p-6">
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={onClose} />
      <div className={`relative w-full max-w-lg max-h-[85vh] flex flex-col rounded-3xl shadow-2xl overflow-hidden ${
        isDarkMode ? 'bg-slate-900 border border-slate-700' : 'bg-white'
      }`}>
        <div className={`flex items-center justify-between p-6 border-b shrink-0 ${isDarkMode ? 'border-slate-700' : 'border-slate-100'}`}>
          <h3 className={`text-xl font-bold ${isDarkMode ? 'text-slate-100' : 'text-slate-900'}`}>{title}</h3>
          <button
            onClick={onClose}
            type="button"
            className={`p-2 rounded-full transition-colors ${isDarkMode ? 'hover:bg-slate-800' : 'hover:bg-slate-100'}`}
          >
            <X className={`w-5 h-5 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`} />
          </button>
        </div>

        <div className="flex-1 min-h-0 overflow-y-auto p-6 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
          {children}
        </div>

        {footer && (
          <div className={`flex items-center justify-end gap-3 px-6 pb-6 pt-4 border-t shrink-0 ${isDarkMode ? 'border-slate-700' : 'border-slate-100'}`}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
